<script setup lang="ts">
import { computed } from 'vue';
import ToggleSwitch from 'primevue/toggleswitch';

interface Props {
  applicability: {
    isPackage: boolean;
    isAir: boolean;
    isHotel: boolean;
    isCruise: boolean;
    isTour: boolean;
  };
}
const props = defineProps<Props>();

const emits = defineEmits<{ 'update:applicability': [value: any] }>();

const applicabilityValue = computed({
  get() {
    return props.applicability;
  },
  set(value) {
    emits('update:applicability', value);
  }
});
</script>

<template>
  <div class="min-w-160 application-type">
    <div class="flex justify-content-around">
      <div class="text-center">
        <div class="mb-1">{{ $t('common.package') }}</div>
        <ToggleSwitch v-model="applicabilityValue.isPackage" :trueValue="true" :falseValue="false" />
      </div>
      <div class="text-center">
        <div class="mb-1">{{ $t('common.air') }}</div>
        <ToggleSwitch v-model="applicabilityValue.isAir" :trueValue="true" :falseValue="false" />
      </div>
      <div class="text-center">
        <div class="mb-1">{{ $t('common.hotel') }}</div>
        <ToggleSwitch v-model="applicabilityValue.isHotel" :trueValue="true" :falseValue="false" />
      </div>
      <div class="text-center">
        <div class="mb-1">{{ $t('common.cruise') }}</div>
        <ToggleSwitch v-model="applicabilityValue.isCruise" :trueValue="true" :falseValue="false" />
      </div>
      <div class="text-center">
        <div class="mb-1">{{ $t('common.tour') }}</div>
        <ToggleSwitch v-model="applicabilityValue.isTour" :trueValue="true" :falseValue="false" />
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.min-w-160 {
  min-width: 160px !important;
  width: 100%;
}
</style>
